import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    meta: {
      icon: 'mdi:person-multiple',
      order: 40,
      title: 'FB业务管理',
    },
    name: 'AdFBBusiness',
    path: '/FB-business',
    children: [
      {
        name: 'AdAccount',
        path: '/account',
        component: () => import('#/views/FB-business/account-list/index.vue'),
        meta: {
          icon: 'mdi:account-outline',
          title: '账户管理',
          keepAlive: true,
        },
      },
      {
        name: 'AdApplyAccount',
        path: '/apply-account',
        component: () =>
          import('#/views/FB-business/apply-account-list/index.vue'),
        meta: {
          icon: 'mdi:account-add-outline',
          title: '开户管理',
          keepAlive: true,
        },
      },
      {
        name: 'AdAccountAssign',
        path: '/account-assign',
        component: () =>
          import('#/views/FB-business/account-assign-list/index.vue'),
        meta: {
          icon: 'mdi:share-variant-outline',
          title: '账户分配',
          keepAlive: true,
        },
      },
      {
        name: 'AdAccountRecharge',
        path: '/account-recharge',
        component: () =>
          import('#/views/FB-business/account-recharge/index.vue'),
        meta: {
          icon: 'mdi:account-multiple-plus-outline',
          title: '账户充值',
          keepAlive: true,
        },
      },
      {
        name: 'AdAccountSubtraction',
        path: '/account-subtraction',
        component: () =>
          import('#/views/FB-business/account-subtraction/index.vue'),
        meta: {
          icon: 'mdi:account-minus-outline',
          title: '账户减款',
          keepAlive: true,
        },
      },
      {
        name: 'AdAccountClear',
        path: '/account-clear',
        component: () => import('#/views/FB-business/account-clear/index.vue'),
        meta: {
          icon: 'mdi:clear-circle-multiple',
          title: '账户清零',
          keepAlive: true,
        },
      },
      {
        name: 'AdServiceFeeConfig',
        path: '/service-fee-config',
        component: () =>
          import('#/views/FB-business/service-fee-config/index.vue'),
        meta: {
          icon: 'mdi:settings-outline',
          title: '服务费配置',
          keepAlive: true,
        },
      },
    ],
  },
]

export default routes
